import { Injectable } from '@angular/core';

import moment from 'moment-timezone';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class DateService {
  convertHoursToTimestamp(value, timezone, day = 1, hours = false) {
    if (!value) {
      return '';
    }

    let time = moment.tz(`${value.hours}:${value.minutes}`, 'HH:mm', timezone);
    /* eslint-disable no-magic-numbers */
    time = this.setTimeToComparisonFormat(time, day);
    let timeMs = time.format('x');
    if (hours && Number(timeMs) < Number(hours[0])) {
      time.add(1, 'days');
      timeMs = time.format('x');
    }
    /* eslint-enable no-magic-numbers */
    return timeMs;
  }

  setTimeToComparisonFormat(time, day = 1) {
    return time.set({
      year: 1970,
      month: 0,
      date: day,
      second: 0,
      millisecond: 0
    });
  }

  formatTimestampToDate(date) {
    return date ? {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    } : null;
  }

  formatNgbDateToTimestamp(date, hours, min) {
    const value = date.split('-');
    return date ? new Date(value[2], value[1] - 1, value[0], hours, min, min).getTime() : null;
  }

  formatStringToNgbDate(data: string): NgbDate {
    const dataInArrayFormat = data.split('-').map(Number);
    return new NgbDate(dataInArrayFormat[2], dataInArrayFormat[1], dataInArrayFormat[0]);
  }
}
